import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CheckIcon from '@material-ui/icons/Check';
import clsx from 'clsx';
import { propNumber, propStr } from '../../../helpers/custom-prop-types';
import UploadingSpinnerIcon from '../../Icon/Svg/UploadingSpinnerIcon';
import ProgressBar from '../ProgressBar/ProgressBar';
const ToastUploadBody = (props) => {
    const { className, progress } = props;
    // 100%でアップロード完了とみなす
    const isUploaded = progress === 100;
    return (_jsx("div", Object.assign({ className: clsx('message_body', className) }, { children: _jsxs("div", Object.assign({ className: 'message_main message_uploading' }, { children: [_jsxs("div", Object.assign({ className: 'uploading_title' }, { children: [_jsx("span", Object.assign({ className: 'title_icon' }, { children: isUploaded ? (_jsx(CheckIcon, { className: 'icon_uploaded' })) : (_jsx(UploadingSpinnerIcon, { className: 'icon_spinner' })) })), _jsx("span", Object.assign({ className: 'title_text' }, { children: isUploaded
                                ? 'アップロードが完了しました'
                                : 'ファイルをアップロードしています' })), !isUploaded && (_jsx("span", Object.assign({ className: 'title_percent' }, { children: `残り${100 - progress}%...` })))] })), _jsx(ProgressBar, { className: 'uploading_bar', progress: progress })] })) })));
};
ToastUploadBody.propTypes = {
    className: propStr(),
    progress: propNumber().isRequired,
};
ToastUploadBody.defaultProps = {
    className: '',
};
export default ToastUploadBody;
